import { Badge } from '#root/components/ui/primitives/badge/badge';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import {
  refund_label,
  getRefundBadgeVariant,
  type RefundStatusType,
} from '#root/models/RefundDTO';
import styles from './refundStatusBadge.module.scss';

interface RefundStatusBadgeProps {
  status: RefundStatusType | string;
  paid_at?: string | null;
  status_label?: string | null;
}

const RefundStatusBadge = ({ status, paid_at, status_label }: RefundStatusBadgeProps) => {
  const variant = getRefundBadgeVariant(status);
  let label = refund_label(status, status_label);

  // Agregar fecha de pago si está pagado
  if (status === 'PAID' && paid_at) {
    const paidDate = format(new Date(paid_at.replace(/ /g, 'T')), 'dd/MM/yyyy', { locale: es });
    label = `${label}: ${paidDate}`;
  }

  return (
    <div className={styles.container}>
      <Badge variant={variant} size="sm">
        {label}
      </Badge>
    </div>
  );
};

export default RefundStatusBadge;
